import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(() => ({
  root: {
    padding: '0px',
  },
}));

export default useStyles;
